import React from 'react';
import {
	Button,
	Modal,
	ModalBody,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalCloseButton,
	ModalOverlay,
} from '@tempo/core';
import {useTranslation} from 'next-i18next';
import UserPasswordForm from '@deezer/next/features/Account/components/UserPasswordForm';
import type {UserForm} from '@deezer/next/features/Account/type';

type EditPasswordModalProps = {
	password: string;
	confirmationPassword: string;
	currentPassword: string;
	action: 'create' | 'edit';
	isDisabled: boolean;
	isRequired: boolean;
	isCurrentUser: boolean;
	onChange: (value: Partial<UserForm>, isValid?: boolean) => void;
	onValidationPassword?: (isValid: boolean) => void;
	isOpen: boolean;
	onClose: () => void;
	onSave: () => void;
};

const EditPasswordModal = ({
	password,
	confirmationPassword,
	currentPassword,
	action,
	isDisabled,
	isRequired,
	isCurrentUser,
	isOpen,
	onClose,
	onSave,
	onChange,
	onValidationPassword,
}: EditPasswordModalProps) => {
	const {t} = useTranslation('d4c');

	const handleClose = () => {
		onChange({currentPassword: '', password: '', confirmationPassword: ''});
		onClose();
	};
	return (
		<Modal isOpen={isOpen} onClose={handleClose} size={'2xl'}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>
					{t('usermanager_title_changepassword_d4c-web')}
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<UserPasswordForm
						data={password}
						isDisabled={isDisabled}
						isRequired={isRequired}
						isCurrentUser={isCurrentUser}
						onChange={onChange}
						onPasswordConfirmationChange={onValidationPassword}
					/>
				</ModalBody>

				<ModalFooter>
					<Button onClick={onClose} variant="ghost">
						{t('generic_action_cancel_d4c-web')}
					</Button>
					<Button
						isDisabled={
							!password ||
							!confirmationPassword ||
							!currentPassword ||
							(action === 'edit' && !password) ||
							password !== confirmationPassword
						}
						onClick={onSave}
					>
						{t('generic_action_save_d4c-web')}
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default EditPasswordModal;
